import { API_BASE_URL, getHeaders } from './config'

export interface SupportTicket {
  id: string
  partner_id: string
  subject: string
  description: string
  status: 'open' | 'in_progress' | 'closed'
  priority: 'low' | 'medium' | 'high' | 'urgent'
  created_at: string
  updated_at: string
}

export async function fetchSupportTickets() {
  const response = await fetch(`${API_BASE_URL}/support/tickets`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch support tickets')
  }
  
  return response.json()
}

export async function fetchSupportTicket(id: string) {
  const response = await fetch(`${API_BASE_URL}/support/tickets/${id}`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch support ticket')
  }
  
  return response.json()
}

export async function createSupportTicket(data: { 
  subject: string
  description: string
  priority: string
}) {
  const response = await fetch(`${API_BASE_URL}/support/tickets`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
  
  if (!response.ok) {
    throw new Error('Failed to create support ticket')
  }
  
  return response.json()
}

export async function updateSupportTicket(
  id: string, 
  data: { status?: string; subject?: string; description?: string; priority?: string }
) {
  const response = await fetch(`${API_BASE_URL}/support/tickets/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  })
  
  if (!response.ok) {
    throw new Error('Failed to update support ticket')
  }
  
  return response.json()
}

export async function deleteSupportTicket(id: string) {
  const response = await fetch(`${API_BASE_URL}/support/tickets/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to delete support ticket')
  }
  
  return response.json()
}

export async function fetchSupportStats() {
  const response = await fetch(`${API_BASE_URL}/support/stats`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch support stats')
  }
  
  return response.json()
}
